import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import LocationNameLink from "../../components/TablePro/components/warehouse/LocationNameLink";

export default function InputLocationName({ entity, value }) {
  const navigate = useNavigate();
  const location = useLocation();
  const initialSearchRef = useRef(location.search);

  useEffect(() => {
    // Preserve existing query parameters and add location details.
    // Only run once on mount — we capture the initial search via ref
    // so closing the modal (which changes the URL) doesn't re-trigger this.
    const queryParams = new URLSearchParams(initialSearchRef.current);
    queryParams.set("locId", entity.id);
    queryParams.set("locType", entity.__typename);
    queryParams.delete("locAssetId");
    navigate({ search: queryParams.toString() });
  }, [entity.id, entity.__typename, navigate]);

  return <LocationNameLink value={value} />;
}
